import axios from 'axios';

// 1. إنشاء نسخة مخصصة من Axios
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL, // هياخد الرابط من ملف الـ env
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// 2. عمل Interceptor للطلبات (Requests)
axiosInstance.interceptors.request.use(
    (config) => {
        try {
            // 1. بنسحب الصندوق بتاع Zustand من المتصفح
            const authStorageString = localStorage.getItem('auth-storage');

            if (authStorageString) {
                // 2. بنحول الصندوق لـ Object ونستخرج التوكن من جواه
                const authStorage = JSON.parse(authStorageString);
                const token = authStorage?.state?.token;

                // 3. لو التوكن موجود، بنحطه في الهيدر
                if (token) {
                    config.headers.Authorization = `Bearer ${token}`;
                }
            }
        } catch (error) {
            console.error("Error reading token from local storage", error);
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login'; // تحويل إجباري لصفحة الدخول
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;